// extracted by mini-css-extract-plugin
module.exports = {"block":"chartSupport_block__Iu2NF"};